import BuildAndSupportDoubleFeatureSection from "./build-and-support-double-feature";
import { ClosingBanner } from "./closing-banner";
import { IntegrationsSection } from "./integrations";
import { JswCollaborateSection } from "./jsw-collaborate";
import { JswDoubleFeatureSection } from "./jsw-double-feature";
import { NoJiraHeroSection } from "./no-jira-hero-section";
import { TestimonialSection } from "./testimonial";
export {
    BuildAndSupportDoubleFeatureSection,
    JswCollaborateSection,
    JswDoubleFeatureSection,
    TestimonialSection,
    ClosingBanner,
    IntegrationsSection,
    NoJiraHeroSection
};
